import React from "react";
import { Helmet } from "react-helmet-async";
import {
  DEFAULT_OG_IMAGE,
  DEFAULT_OG_IMAGE_ALT,
  SITE_ORIGIN,
  robotsContent,
} from "./siteOrigin";

const SEOHead = ({
  title,
  description,
  keywords = [],
  canonicalUrl,
  ogImage,
  ogImageAlt = DEFAULT_OG_IMAGE_ALT,
  ogType = "website",
  twitterCard = "summary_large_image",
  structuredData,
  additionalStructuredData = [],
  noIndex = false,
  noFollow = false,
  additionalMeta = [],
}) => {
  const path =
    canonicalUrl ||
    (typeof window !== "undefined" ? window.location.pathname : "/");
  const fullCanonicalUrl = `${SITE_ORIGIN}${path}`;
  const fullOgImage = ogImage
    ? ogImage.startsWith("http")
      ? ogImage
      : `${SITE_ORIGIN}${ogImage}`
    : `${SITE_ORIGIN}${DEFAULT_OG_IMAGE}`;

  const defaultKeywords = [
    "bowling tournament",
    "tournament management",
    "bowling scores",
    "tournament registration",
    "bowling league",
    "tournament results",
    "bowling app",
    "tournament organizer",
    "bowling center",
    "tournament software",
  ];

  const allKeywords = [...defaultKeywords, ...keywords].join(", ");

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={allKeywords} />
      <link rel="canonical" href={fullCanonicalUrl} />

      <meta
        name="robots"
        content={robotsContent({ noIndex, noFollow })}
      />
      <meta
        name="googlebot"
        content={robotsContent({ noIndex, noFollow })}
      />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonicalUrl} />
      <meta property="og:image" content={fullOgImage} />
      <meta property="og:image:alt" content={ogImageAlt} />
      <meta property="og:site_name" content="Bowling Tournament App" />

      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullOgImage} />
      <meta name="twitter:image:alt" content={ogImageAlt} />

      {additionalMeta.map((meta, index) => (
        <meta key={index} {...meta} />
      ))}

      {[structuredData, ...additionalStructuredData].filter(Boolean).map(
        (data, index) => (
          <script key={index} type="application/ld+json">
            {JSON.stringify(data)}
          </script>
        )
      )}
    </Helmet>
  );
};

export default SEOHead;
